// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"93":"fcb70dbb","111":"5ba28ec8","115":"5c30b331","363":"48462b4d","481":"d5798d3f","663":"30ca1e9f","742":"6ae96d6d","797":"ea7a6f19","867":"783a3f54","950":"bba35825"}[chunkId] + ".chunk.js";
};